import { render, staticRenderFns } from "./KegiatanPelayananRujukan.vue?vue&type=template&id=5e5d31d6"
import script from "./KegiatanPelayananRujukan.vue?vue&type=script&lang=js"
export * from "./KegiatanPelayananRujukan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e5d31d6')) {
      api.createRecord('5e5d31d6', component.options)
    } else {
      api.reload('5e5d31d6', component.options)
    }
    module.hot.accept("./KegiatanPelayananRujukan.vue?vue&type=template&id=5e5d31d6", function () {
      api.rerender('5e5d31d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananRujukan.vue"
export default component.exports